// Regras de nome de personagem, inspiradas nas do Tibia.

const RESERVED = ['gm', 'cm', 'god', 'tutor', 'admin', 'staff', 'gamemaster', 'support', 'noxara', 'cipsoft', 'claude'];

/** Arruma espaços e maiúsculas: "  joão   da silva " -> "João Da Silva". */
export function normalizeName(raw: string): string {
  return raw
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((w) => (w ? w[0]!.toLocaleUpperCase('pt-BR') + w.slice(1).toLocaleLowerCase('pt-BR') : w))
    .join(' ');
}

/** Retorna a mensagem de erro, ou null se o nome (já normalizado) é válido. */
export function validateName(name: string): string | null {
  if (name.length < 2 || name.length > 29) return 'O nome precisa ter de 2 a 29 letras.';
  if (!/^[A-Za-z]+( [A-Za-z]+)*$/.test(name)) return 'Use só letras sem acento, com um espaço entre as palavras.';
  const words = name.toLowerCase().split(' ');
  if (words.length > 3) return 'Use no máximo 3 palavras.';
  if (words.some((w) => w.length < 2)) return 'Cada palavra precisa ter ao menos 2 letras.';
  if (words.some((w) => RESERVED.includes(w))) return 'Esse nome é reservado.';
  if (/(.)\1\1/.test(name.toLowerCase())) return 'Não repita a mesma letra três vezes seguidas.';
  return null;
}
